const Filter = (state = [], action) => {
    switch (action.type) {
        case  'SET_FILTER':
            return action.payload;
    }
    return state
}

export default Filter;




// WEBPACK FOOTER //
// ./src/reducers/Filter.js